import { getQueryParameters } from "../Wizards/Entities/QueryParametersHelper";
import { LandingAction } from "../Actions/Action";

export class Method {
    private static getInstructionId(): number {
        const paramters = getQueryParameters();
        return paramters["instructionid"];
    }

    public static Exit() {
        const instructionId = this.getInstructionId();
        LandingAction.postCancel(instructionId, () => {
            this.BackToWrap();
        });
    }

    public static BackToWrap() {
        window.location.assign(window.location.origin + "/wpadviser/en-gb/dashboard/home/main/dashboard");
    }

    public static Oridinal(number: number): string {
        let work = number.toString();
        if (number % 100 == 11 || number % 100 == 12 || number % 100 == 13) {return work + "th";}
        switch (number % 10) {
            case 1:
                work += "st";
                break;
            case 2:
                work += "nd";
                break;
            case 3:
                work += "rd";
                break;
            default:
                work += "th";
                break;
        }
        return work;
    }
}
